import { render, staticRenderFns } from "./userquiz.html?vue&type=template&id=7845cff2&scoped=true&"
import script from "./userquiz.js?vue&type=script&lang=js&"
export * from "./userquiz.js?vue&type=script&lang=js&"
import style0 from "./userquiz.css?vue&type=style&index=0&id=7845cff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845cff2",
  null
  
)

export default component.exports